module.exports = __webpack_public_path__ + "png/full_house.png?efcac98a432f35fa5413bdd35f783009";